import axios from './api-axios'
import fn from './common-func'
import menuList from '@/components/menu-list'
import stoneDataTable from '@/components/stone-data-table'
import stoneDataTableServer from '@/components/stone-data-table-server'

export default {
  mixins: [fn],
  components: {menuList, stoneDataTable, stoneDataTableServer},
  created () {
    // page_seq가 존재할 경우에만 현재 페이지 정보를 가지고 온다.
    if (this.$route.meta.page) {
      // this.getCurrentNaviPath(this.$route.meta.page)
    } else {
      if (this.$parent.$parent && this.$parent.$parent.$parent) {
        this.$parent.$parent.$parent.naviPath = []
      }
    }
    // 브라우저 뒤로가기 이벤트가 발생할 경우
    window.addEventListener('popstate', () => {
      if (this.onPopStateEventHandler && typeof this.onPopStateEventHandler === 'function') {
        this.onPopStateEventHandler()
      }
    }, {once: true})
    // window.onpopstate = event => {
    //   // console.log('location: ' + document.location + ', state: ' + JSON.stringify(event.state))
    //   if (this.onPopStateEventHandler && typeof this.onPopStateEventHandler === 'function') {
    //     this.onPopStateEventHandler()
    //   }
    // }
  },
  mounted () {
  },
  data () {
    const pageSize = 3000
    return {
      naviPath: [],
      stoneConfig: {
        dataTableLoading: true
      },
      searchLoading: false,
      examTableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false},
        {label: '시험명', prop: 'title', align: 'left', width: 200},
        {label: '유형', prop: 'exam_type_name', align: 'center', width: 60},
        {label: '과목', prop: 'subject', align: 'center', width: 60},
        {label: '시험인원', prop: 'exam_user_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        {label: '응시인원', prop: 'exam_entry_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        {label: '응시율', prop: 'exam_entry_rate', align: 'right', formatter: this.columnFormatterRate, width: 70, dataType: 'percentage', format: '0.0%'},
        {label: '생성일', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate, width: 70, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '공개일', prop: 'open_dt', align: 'center', formatter: this.columnFormatterDate, width: 70, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '종료일', prop: 'close_dt', align: 'center', formatter: this.columnFormatterDate, width: 70, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '상태', prop: 'stat_name', align: 'center', width: 60}
      ],
      defaultTableProps: {height: this.getScreenHeight()},
      defaultFilterTableProps: {height: this.getScreenHeight(49)},
      emptyPageSize: pageSize,
      emptyPaginationProps: {layout: '', pageSizes: [pageSize]},
      excelLoading: false,
      zipLoading: false,
      searchDetailVisible: false,
      stoneDataTableCurrentPage: 1,
      stoneDataTableSort: {},
      btnExcelName: 'Excel',
      isPageLoadInit: true,
      queryParam: {},
      isCurrentPage: false
    }
  },
  methods: {
    getCurrentNaviPath (menuCode) {
      axios.get(`/page/path/${menuCode}`)
        .then(response => {
          if (this.$parent.$parent.$parent) {
            this.$parent.$parent.$parent.naviPath = response.data
          }
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    commonUploadFilePreview (file) {
      // 첨부파일 다운로드
      // window.location.href = file.download_url
      if (file.download_url !== undefined) {
        window.location.assign(file.download_url)
      }
    },
    commonBeforeUploadFileRemove (file, fileList) {
      return this.$confirm(`<strong>${file.name}</strong> 파일을 삭제하시겠습니까？`, '', {type: 'warning', dangerouslyUseHTMLString: true})
    },
    commonUploadFileRemove (file, fileList) {
      if (file.response !== undefined) {
        this.deleteFile(file.response.file_seq)
      } else if (file.file_seq) {
        this.deleteFile(file.file_seq)
      }
    },
    deleteFile (fileSeq, isMessage = true, callback = null) {
      axios.delete(`/file/${fileSeq}`)
        .then(response => {
          if (isMessage) {
            this.$message('삭제되었습니다.')
          }
          if (callback !== null && typeof callback === 'function') {
            callback.apply(this, [response.data])
          }
        })
        .catch(() => {
          this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
        })
    },
    loadStoneDataTable (url, param, isPost = true, isFirst = true) {
      return new Promise((resolve, reject) => {
        if (this.stoneConfig.dataTableLoading) {
          this.searchLoading = true
        }
        axios({method: isPost ? 'post' : 'get', url: url, data: param})
          .then(response => {
            this.searchLoading = false
            if (isFirst) {
              const dataTables = this.$children.find(x => x.localCurrentPage)
              if (dataTables) {
                dataTables.localCurrentPage = 1
              }
            }
            resolve(response)
          })
          .catch(error => {
            this.searchLoading = false
            reject(error)
          })
      })
    },
    exportExcel (param) {
      this.excelLoading = true
      axios.request({
        url: '/excel',
        method: 'post',
        data: param,
        responseType: 'blob' // important
      })
        .then(response => {
          const filename = decodeURIComponent(response.headers['file-name'])
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            // link.download = filename
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.excelLoading = false
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename)
          }
        })
        .catch(error => {
          this.excelLoading = false
          console.error(error)
          this.$message.error({message: '엑셀 다운로드에 실패하였습니다.', showClose: true})
        })
    },
    handleTableSelectionToggle (ref, row) {
      if (!this.$refs[ref].$refs[ref].$refs.elTable) {
        return
      }
      this.$refs[ref].$refs[ref].$refs.elTable.toggleRowSelection(row)
    },
    handleTableSelectionToggleAll (ref, data, isToggle) {
      if (!this.$refs[ref].$refs[ref].$refs.elTable) {
        return
      }
      const dataTables = this.$refs[ref].$refs[ref].$refs.elTable
      if (isToggle) {
        data.forEach(row => {
          dataTables.toggleRowSelection(row, true)
        })
      } else {
        data.forEach(row => {
          dataTables.clearSelection()
        })
      }
    },
    getDataTable (refId = 'stoneDataTable') {
      const dataTables = this.$refs[refId]
      if (dataTables) {
        return dataTables.$refs[refId].$refs.elTable
      }
      return dataTables
    },
    setDataTableHeight (value = 0, refId = 'stoneDataTable') {
      const dataTables = this.getDataTable(refId)
      if (dataTables) {
        // console.log('datatables layout : ', dataTables.layout)
        // console.log('datatables layout.table : ', dataTables.layout.table)
        const dataTablesHeight = this.getScreenHeight(value)
        // dataTables.$refs[refId].$refs.elTable.layout.bodyHeight = dataTablesHeight - 40
        dataTables.layout.setHeight(dataTablesHeight)
        // dataTables.$refs[refId].$refs.elTable.doLayout()
      }
    },
    clearDataTableSort (refId = 'stoneDataTable') {
      const dataTables = this.getDataTable(refId)
      dataTables.clearSort()
    },
    handleNoticeDiallogLoad (boardSeq, refId = 'notice') {
      this.$refs[refId].dialogVisible = true
      this.$refs[refId].loadNoticeInfo(boardSeq)
    },
    clearDataTableCurrentRow (refId = 'stoneDataTable') {
      const dataTables = this.getDataTable(refId)
      if (dataTables) {
        dataTables.setCurrentRow(null)
      }
    },
    handlerStoneDataTableCurrentPageChange (value, prop = 'stoneDataTableCurrentPage') {
      this[prop] = value
    },
    handlerStoneDataTableSortChange ({ column, prop, order }) {
      this.stoneDataTableSort = { prop: prop, order: order }
    },
    routerPageChange (routerName, routerParmas, currentPage = 'stoneDataTableCurrentPage', sort = 'stoneDataTableSort') {
      const storeParams = {
        name: this.$route.name,
        current_page: this[currentPage],
        sort: this[sort]
      }
      this.$store.dispatch('PAGE_PARAMS_REGISTER', storeParams).then(() => {
        this.$router.push({name: routerName, params: routerParmas})
      })
    },
    routerPageChangeServer (routerName, routerParmas) {
      const storeParams = {
        name: this.$route.name,
        query_info: this.queryParam
      }
      this.$store.dispatch('PAGE_PARAMS_REGISTER', storeParams).then(() => {
        this.$router.push({name: routerName, params: routerParmas})
      })
    },
    checkedStoreCurrentDataTable (tableRef = 'stoneDataTable', currentPage = 'stoneDataTableCurrentPage') {
      const params = this.$store.getters.page_params
      if (this.$route.name !== params.name) {
        return
      }
      // console.log('store params : ', params)
      // 현재 페이지 정보
      if (params.current_page) {
        this[currentPage] = params.current_page
      }
      // 정렬 정보
      if (params.sort) {
        const dataTables = this.getDataTable(tableRef)
        if (dataTables) {
          dataTables.sort(params.sort.prop, params.sort.order)
        }
      }
      this.$store.dispatch('PAGE_PARAMS_DELETE')
    },
    initStoneDataTable (tableRef = 'stoneDataTable', currentPage = 'stoneDataTableCurrentPage') {
      this.clearDataTableSort(tableRef)
      if (this[currentPage]) {
        this[currentPage] = 1
      }
    },
    retrieveDummy () {
      axios.get('/dummy')
        .then(response => {
          if (this.$route.params.query_info) {
            this.$nextTick(() => {
              this.retrieveParams(this.$route.params.query_info)
            })
          } else {
            this.retrieve()
          }
        })
    },
    retrieveParams (params) {
      if (this.isPageLoadInit) {
        this.isPageLoadInit = false
      }
      if (params.search) {
        this.search = params.search
      }
      const queryInfo = params.query
      if (queryInfo.sort.prop) {
        const dataTables = this.getDataTable('dataTableServer')
        dataTables.sort(queryInfo.sort.prop, queryInfo.sort.order)
        this.isCurrentPage = true
      } else {
        this.tableLoadData(queryInfo, true)
      }
      // localStorage page_params를 삭제한다.
      this.$store.dispatch('PAGE_PARAMS_DELETE')
    },
    checkedPageLoadInit (queryInfo) {
      if (this.isPageLoadInit) {
        this.isPageLoadInit = false
        return true
      }
      this.queryParam = {query: queryInfo, search: this.search}
      return false
    },
    setQueryParamPaging (isClear) {
      if ((this.isCurrentPage || isClear) && this.$route.params.query_info) {
        this.$refs.dataTableServer.localCurrentPage = this.$route.params.query_info.query.page
        if (this.isCurrentPage) {
          this.isCurrentPage = false
        }
        this.$route.params.query_info = null
      }
    },
    membershipRowClassName ({row, rowIndex}) {
      return row.user_use_yn === 'N' ? 'leave-user-row' : ''
    },
    examUserRowClassName ({row, rowIndex}) {
      let className = row.user_use_yn === 'N' ? 'leave-user-row' : ''
      className += row.stat === 'S' ? ' success-row' : ''
      return className
    },
    exportExamPaperZip (param, datatables) {
      this.zipLoading = true
      axios.request({
        url: '/download/paper/zip',
        method: 'post',
        data: param,
        responseType: 'blob' // important
      })
        .then(response => {
          const filename = decodeURIComponent(response.headers['file-name'])
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            // link.download = filename
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.zipLoading = false
            if (this.$refs[datatables] && this.$refs[datatables].$refs[datatables].$refs.elTable) {
              this.$refs[datatables].$refs[datatables].$refs.elTable.clearSelection()
            }
          } else {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename)
          }
        })
        .catch(error => {
          this.zipLoading = false
          console.error(error)
          this.$message.error({message: '파일 다운로드에 실패하였습니다.', showClose: true})
        })
    },
    handleSendGradeDialog (refId = 'sendGrade') {
      this.$refs[refId].dialogVisible = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/common-mixins.js